export const roleStatuses = {
    pending: "pending",
    pgNeedApprove: "pg_need_approve",
    approved: "approved",
    approvedImportant: "approved_important",
    approvedAdditionalApprovals: "approved_additional_approvals",
    approvedAdditionalApprovalsImportant: "approved_additional_approvals_important",
    productionRole: "production_role"
};

export const cisoStatuses = {
    notApproved: "not_approved",
    cisoApproved: "ciso_approved",
    cisoApprovedImportant: "ciso_approved_important",
    cisoApprovedAdditionalApprovals: "ciso_approved_additional_approvals",
    cisoApprovedAdditionalApprovalsImportant: "ciso_approved_additional_approvals_important"
}

export const ownerStatuses = {
    notApproved: "not_approved",
    ownerApproved: "owner_approved",
    ownerApprovedAdditionalApprovals: "owner_approved_additional_approvals"
};

export const messageTypes = { error: "error", success: "success", information: "info" };

export const eventTypesForBus = {
    createRole: "createRole",
    assignPGs: "assignPGs",
    approveRole: "approveRole",
    cisoApproved: "cisoApproved",
    unexpectedError: "unexpectedError",
    createRoleValidation: "createRoleValidation",
    notSelectedEntity: "notSelectedEntity",
    removedEmployee: "removedEmployee",
    editedRole: "editedRole",
    logout: "logout",
    loadingReportError: "loadingReportError",
    ownerChange: "ownerChange",
    saveReviewSuccess: "saveReviewSuccess",
    saveReviewError: "saveReviewError",
    sendEmailsSuccess: "sendEmailsSuccess",
    sendEmailsError: "sendEmailsError",
    saveCommentSuccess: "saveCommentSuccess",
    saveCommentError: "saveCommentError",
    saveFeedbackSuccess: "saveFeedbackSuccess",
    saveFeedbackError: "saveFeedbackError",
    setResponsibleManagerSuccess: "setResponsibleManagerSuccess",
    setResponsibleManagerError: "setResponsibleManagerError",
    setUnmatchedAccountSuccess: "setUnmatchedAccountSuccess",
    setManagerReviewsAsCompletedSuccess: "setManagerReviewsAsCompletedSuccess",
    setManagerReviewsAsCompletedError: "setManagerReviewsAsCompletedError",
    uploadManualDataFileSuccess: "uploadManualDataFileSuccess",
    uploadManualDataFileError: "uploadManualDataFileError",
    resetAccountReviewActionError: "resetAccountReviewActionError",
    markSystemsAsReviewedSuccess: "markSystemsAsReviewedSuccess",
    markSystemsAsReviewedError: "markSystemsAsReviewedError",
    fileNotSelected: "fileNotSelected"
};

export const eventBusMessages = {
    createRoleSuccess: "Role was created successfully",
    createRoleError: "Role was not created successfully due to an unexpected error",
    assignPermissionGroupsSuccess: "Selected Permission Groups were assigned to the role!",
    assignPermissionGroupsError: "Selected Permission Groups were not assigned to the role due to an unexpected error!",
    assignRoleSuccess: "Selected role was assinged!",
    approveRoleSuccess: "Selected role was approved!",
    approveRoleError: "Selected role was not approved due to an unexpected error!",
    cisoApproved: "Role was succefully approved by CISO",
    createRoleValidation: "Both fields should be filled before submitting new role",
    notSelectedPGs: "Please select a Permission Group before submitting a role",
    notSelectedEmployee: "Please select employees before assigning the selected role",
    unexpectedError: "Something went wrong, please try again!",
    removedEmployee: "The selected employees were removed from the role",
    editedRole: "The selected role was successfully edited",
    logout: "User was logged out successfully",
    loadingReportError: "Error occured while generating the report.",
    ownerChangeSucess: "The owner was updated successfully",
    saveReviewError: "Some of the fields are invalid!",
    saveReviewSuccess: "Review was submitted successfully",
    sendEmailsSuccess: "Sending Emails",
    sendEmailsError: "There was problem sending emails",
    saveCommentSuccess: "Comment was submitted successfully",
    saveCommentError: "Error while submitting the comment",
    saveFeedbackSuccess: "Thank you for your feedback!",
    saveFeedbackError: "Error while processing the feedback",
    setManagerReviewsAsCompletedSuccess: "All manager reviews were marked as completed for the current quarter",
    setManagerReviewsAsCompletedError: "Error occured while changing completion status for manager reviews",
    uploadManualDataFileSuccess: "File is uploaded for processing",
    uploadManualDataFileError: "Error while uploading file!",
    setResponsibleManagerSuccess: "Responsible manager set successfully",
    setResponsibleManagerError: "There was a problem setting responsible manager",
    markSystemsAsReviewedSuccess: "Systems marked as reviewed successfully",
    markSystemsAsReviewedError: "There was a problem while setting systems as reviewed",
    fileNotSelected: "No file was selected"
}

export const emptyGuid = '00000000-0000-0000-0000-000000000000';

export const employeeReviewActions = [
    { id: 0, name: "Missing Action" },
    { id: 1, name: "Approve" },
    { id: 2, name: "Revoke" },
    { id: 3, name: "Change" },
    { id: 4, name: "Delegate" }
]

export const qarAdminNavListItems = {
    qarSystems: "QAR Systems",
    notRecognizedAccounts: "Not Recognized Accounts",
    manualDataUpload: "Manual Data Import"
}